export default {
    userBaseData: 'Daten',
    userSignature: 'Signatur',
    userReports: 'Meine Auswertungen',
    userFilters: 'Gespeicherte Filterkombinationen',
    userOrganisations: 'Organisationen',
    userActivities: 'Historie',
    userCommunications: 'Kommunikation'
}